<template>
    <div class="notification-sidebar">
        <div class="top">
            <div class="first">
                <SupsisButton ghost classNames="border-none" @click="goBack">
                    <i class="material-icons">chevron_left</i>
                    {{ $t("message.turnBack") }}
                </SupsisButton>
            </div>
            <div class="second">
                <div class="btnGroup">
                    <SupsisButton classNames="btnGroupItem" ghost @click="goActivities">{{
                        $t("notification.activities")
                    }}</SupsisButton>
                    <SupsisButton classNames="btnGroupItem selected" primary @click="goNotifications"
                        >{{ $t("settings.notifications") }}
                    </SupsisButton>
                </div>
            </div>
            <div class="third">
                <div>
                    <div>{{ $t("notification.dateBetween") }}</div>
                    <div class="date-calender">
                        <input
                            type="date"
                            :value="startDateValue"
                            :placeholder="$t('message.startDate')"
                            class="custom-date-input"
                            @input="onStartDateChange"
                        />
                        <input
                            type="date"
                            :value="endDateValue"
                            :placeholder="$t('message.endDate')"
                            class="custom-date-input"
                            @input="onEndDateChange"
                        />
                    </div>
                </div>
                <div>
                    <div>{{ $t("notification.actionType") }}</div>
                    <a-select
                        v-model="filters.activityTypes"
                        class="select-multiple"
                        mode="multiple"
                        :placeholder="$t('notification.actionType')"
                        :options="types"
                    ></a-select>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import Vue from "vue";
import { mapState } from "vuex";
import _ from "lodash";
import SupsisButton from "../Settings/components/SupsisButton.vue";

export default Vue.extend({
    name: "ActivitySidebar",
    components: { SupsisButton },
    props: {
        filter: {
            type: Object,
            default: () => ({
                actorIds: [],
                startDate: null,
                endDate: null,
                activityTypes: [],
            }),
        },
    },
    data: () => ({
        filters: {},
        typeValues: [
            "chat-assign",
            "ticket-assign",
            "task-assign",
            "chat-close-own",
            "tag-actions-to-visitor",
            "create-ticket",
            "note-actions-to-visitor",
            "visitor-profile-updates",
            "chat-start",
            "user-crud",
            "department-crud",
            "settings-crud",
            "integration-channel-crud",
            "login-form-crud",
            "banned-word-crud",
            "email-account-crud",
            "prepared-content-crud",
            "role-crud",
            "tag-crud",
            "welcome-message-crud",
            "webhook-crud",
            "automation-created",
            "automation-deleted",
            "automation-published",
            "automation-unpublished",
            "automation-updated",
            "billing-events",
            "task-workflow-crud",
            "task-crud",
            "system-status",
            "chatbot-story-crud",
            "chatbot-forward-chat",
            "chatbot-user-segment-crud",
            "chatbot-credit-low",
            "whatsapp-credit-low",
            "whatsapp-customer-group-crud",
            "whatsapp-broadcast-message-crud",
            "whatsapp-template-message-crud",
            "waba-supsis-partner-remove",
            "waba-supsis-partner-added",
            "waba-supsis-account-deleted",
            "waba-supsis-account-violation",
            "waba-supsis-ad-account-linked",
            "waba-supsis-auth-intl-price-eligibility-update",
            "waba-supsis-disabled-update",
            "waba-supsis-mm-lite-terms-signed",
            "waba-supsis-partner-app-installed",
            "waba-supsis-partner-app-uninstalled",
            "waba-supsis-partner-client-certification-status-update",
            "waba-supsis-business-primary-location-country-update",
            "waba-supsis-volume-based-pricing-tier-update",
            "waba-supsis-message-template-components-update",
            "waba-supsis-message-template-status-update",
            "waba-supsis-template-category-update",
        ],
    }),
    computed: {
        types() {
            return this.typeValues.map((value) => ({
                value,
                label: this.$t(`notification.activityTypeLabels["${value}"]`),
            }));
        },
        startDateValue() {
            if (!this.filters.startDate) return "";
            return this.$moment(this.filters.startDate).format("YYYY-MM-DD");
        },
        endDateValue() {
            if (!this.filters.endDate) return "";
            return this.$moment(this.filters.endDate).format("YYYY-MM-DD");
        },
    },
    methods: {
        onStartDateChange(event) {
            const value = event.target.value;
            if (value) {
                this.$set(this.filters, 'startDate', this.$moment.utc(value, "YYYY-MM-DD").startOf("day").toDate());
            } else {
                this.$set(this.filters, 'startDate', null);
            }
        },
        onEndDateChange(event) {
            const value = event.target.value;
            if (value) {
                this.$set(this.filters, 'endDate', this.$moment.utc(value, "YYYY-MM-DD").endOf("day").toDate());
            } else {
                this.$set(this.filters, 'endDate', null);
            }
        },
        goBack() {
            this.$router.push("/chat");
        },
        goActivities() {
            this.$router.push("/activities");
        },
        goNotifications() {
            this.$router.push("/notifications");
        },
    },
    mounted() {
        this.filters = _.cloneDeep(this.filter);
    },
    watch: {
        filter: {
            deep: true,
            handler() {
                if (!_.isEqual(this.filters, this.filter)) {
                    this.filters = this.filter;
                }
            },
        },
        filters: {
            deep: true,
            handler(newVal, oldVal) {
                    this.$emit("filtered", this.filters);
            },
            immediate: false,
        },
    },
});
</script>
<style lang="scss">
.notification-sidebar {
    .third {
        .date-calender {
            display: flex;
            flex-direction: column;
            gap: 5px;
            
            .custom-date-input {
                width: 100%;
                padding: 10px 14px;
                border: 1px solid #d9d9d9;
                border-radius: 4px;
                    background-color: #f1f4f7;
                font-size: 14px;
                outline: none;
                transition: all 0.3s;
                
                &:focus {
                    border-color: #40a9ff;
                    box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.2);
                }
                
                &::-webkit-calendar-picker-indicator {
                    cursor: pointer;
                }
            }
        }
    }
    .ant-select {
        width: 100%;
        .ant-select-selection {
            background-color: #f1f4f7 !important;
            .ant-select-selection__choice {
                color: rgb(255 255 255);
                background-color: #22272d;
                border-radius: 5px;
                svg[data-icon="close"] {
                    fill: white;
                }
            }
        }
    }
}
</style>
<style scoped lang="scss">
.notification-sidebar {
    overflow-y: auto;
    height: calc(100vh - 93px);
    max-height: 100%;
    width: 275px;
    position: sticky;
    top: 0;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    border-right: 1px solid var(--color-border-default);

    .border-none {
        border: none !important;
    }

    .top {
        display: flex;
        flex-direction: column;
        gap: 20px;
        padding: 20px 0;

        .first,
        .second,
        .third {
            width: 100%;
            padding: 0 20px;
        }

        .third {
            width: 100%;
            display: flex;
            gap: 10px;
            flex-direction: column;
        }

        .btnGroup {
            display: flex;
            border: 1px solid var(--color-border-default);
            border-radius: 6px;
            background: var(--color-bg-neutral-default);
            padding: 2px;

            .btnGrupItem {
                &.selected {
                    background: var(--color-bg-oncomponent-default);
                    box-shadow: var(--shadow-interaction-200);
                }
            }

            .supsis-button {
                border: none !important;
                font-size: 14px;
            }
        }

        .filter-groups {
            display: flex;
            flex-direction: column;

            .filter-group {
                display: flex;
                flex-direction: row;
                gap: 5px;
                align-items: center;
                padding: 16px 20px;
                cursor: pointer;

                &:not(.expanded):hover {
                    background: var(--color-bg-hover);
                    text-decoration: underline;
                }
            }

            .filters-wrapper {
                padding: 5px 16px !important;

                .filters {
                    position: relative;
                    border-radius: 4px;
                    border: 1px solid var(--color-border-default);
                    background-color: #f5f7fa;

                    .filter {
                        display: flex;
                        align-items: flex-start;
                        margin: 7px 0;

                        .filter-name {
                            flex: 1;
                            padding: 0 3px;
                            padding-top: 5px;
                        }
                    }

                    .close-icon {
                        position: absolute;
                        right: 5px;
                        top: 5px;
                        cursor: pointer;
                    }

                    .from,
                    .to {
                        padding: 5px;
                        cursor: text;
                        margin: 20px 8px;
                        border: 1px solid var(--color-border-default);
                        border-radius: 4px;
                    }
                }
            }
        }
    }

    .bottom {
        padding: 20px;
        display: flex;
        justify-content: center;
        align-items: center;
    }
}
</style>
